// Libraries
import { Button } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React from "react";

// Core
import { isEmptyOrWhitespace } from "Core/Utils/Utils";
import { isNullOrUndefined } from "util";

// Custom
import { StandardButtonStyle } from "./ButtonStyling";

interface IProps {
    canExecute?: boolean;
    className?: string;
    displayName: string;
    execute?: () => void;
    isSubmit?: boolean;
}

export const StandardButton: React.FC<IProps> = props => {
    // #region Code Behind

    const standardButtonStyle = StandardButtonStyle();

    const getClassNames = (): string => {
        let classNames = standardButtonStyle.root;

        if (!isEmptyOrWhitespace(props.className)) {
            classNames = `${classNames} ${props.className}`;
        }

        return classNames;
    };

    const getType = (): "button" | "submit" | "reset" => {
        return !isNullOrUndefined(props.isSubmit) && props.isSubmit ? "submit" : "button";
    };

    const isDisabled = (): boolean => {
        return !isNullOrUndefined(props.canExecute) ? !props.canExecute : false;
    };

    const onClick = (): void => {
        if (!isNullOrUndefined(props.execute)) {
            props.execute();
        }
    };

    // #endregion Code Behind

    return useObserver(() => (
        <Button aria-label="close" className={getClassNames()} disabled={isDisabled()} onClick={onClick} type={getType()} variant="contained">
            {props.displayName}
        </Button>
    ));
};
